/* eslint-disable */
export const arrowIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.3614 11.617H3.87231M3.87231 11.617L9.68072 5.80859M3.87231 11.617L9.68072 17.4254" stroke="currentColor" stroke-width="1.4521" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow' as const,
};
